<template>
  <div v-if="simulationData.modals.backfilling.blocks.length>0" class="modal" id="backfillingModal" tabindex="-1" aria-labelledby="backfillingModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="backfillingModalLabel">
            <i class="fa-duotone fa-fill-drip"></i> Backfilling
          </h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div>
            <p>
              You will fill back the following blocks:<br>
              <span v-for="block in modalBlocks">
              #{{ block.id}}
              </span>
            </p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary me-auto" data-bs-dismiss="modal">Cancel</button>
            <button type="button" class="btn btn-primary float-end" @click="backfilling">
              <i class="fa-duotone fa-fill-drip"></i> Backfilling
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {Modal} from 'bootstrap'
import Simulation from "@/views/Simulation/Simulation.vue";

export default {
  name: "Backfilling",
  components: { Simulation },
  props: ["initData", "contents", "simulationData"],
  data() {
    return {
      Simulation
    }
  },
  computed: {
    modalBlocks() {
      return this.simulationData.modals.backfilling.blocks
    },
    content() {
      return this.contents.backfillingModal
    },
  },
  methods: {
    backfilling(){
      this.Simulation.methods.action(this, 29, this.modalBlocks,null)

      //CLOSE MODAL
      let modalInstance = Modal.getInstance(document.getElementById("backfillingModal"));
      modalInstance.hide();
    },
    openModal(e, blocks, map) {
      e.simulationData.modals.backfilling.blocks = blocks

      setTimeout(() => {
        let modalInstance = new Modal(document.getElementById("backfillingModal"));
        modalInstance.show();
      }, 0);
    }
  },
};
</script>

<style scoped>

</style>